import { createApp } from 'vue'
import App from './App.vue'
import './style.css'

const app = createApp(App)

// Provide showLogin globally — Sidebar and other components inject it
app.provide('showLogin', (message?: string, title?: string) => {
  // We need to call the globally exposed function
  ;(window as any).showLoginModal?.(message, title)
})

app.mount('#app')
